module.exports = __webpack_public_path__ + "static/media/default-no-img.0a6e6a4e.jpeg";